// extracted by mini-css-extract-plugin
export var fileExt = "_vm-8";
export var fileIcon = "_vm-6";
export var fileLink = "_vm-5";
export var fileName = "_vm-7";
export var image = "_vm-1";
export var imageError = "_vm-3";
export var imageErrorIcon = "_vm-4";
export var imageLink = "_vm-0";
export var imageLoaded = "_vm-2";